// "Not interested" X-button behavior - inverse of wrpg-wishlist.js. Same
// login-modal / App Proxy pattern, left-side placement, shared variant picker
// in mode=exclude (plus an "exclude entire product" action).
(() => {
  if (window.__wrpgExclusionsLoaded) return;
  window.__wrpgExclusionsLoaded = true;

  const ENDPOINT = "/apps/wrpg/exclusions";
  const LOGIN_MODAL_ID = "WrpgWishlistLoginModal";

  const state = {
    mode: "unknown",
    items: new Map(),
    ready: null,
  };

  function isActive(handle) {
    return (state.items.get(handle) || new Set()).size > 0;
  }

  function syncButtons() {
    document.querySelectorAll("[data-wrpg-exclude-toggle]").forEach((button) => {
      const handle = button.dataset.productHandle;
      const active = isActive(handle);
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", String(active));
      const label = active ? button.dataset.labelRemove : button.dataset.labelAdd;
      if (label) {
        button.setAttribute("aria-label", label);
        const visibleLabel = button.querySelector(".wrpg-exclude-button__label");
        if (visibleLabel) visibleLabel.textContent = label;
      }
    });
  }

  function announce() {
    document.dispatchEvent(
      new CustomEvent("wrpg:exclusions:change", {
        detail: {
          handles: [...state.items.keys()],
          items: [...state.items.entries()].map(([handle, variants]) => ({
            handle,
            variantIds: [...variants],
          })),
        },
      }),
    );
  }

  function applyServerPayload(data) {
    const next = new Map();
    (data.items || []).forEach((item) => {
      const set = next.get(item.handle) || new Set();
      set.add(item.variantId || "");
      next.set(item.handle, set);
    });
    state.items = next;
  }

  function openLoginModal(opener, reason) {
    const modal = document.getElementById(LOGIN_MODAL_ID);
    if (!modal || typeof modal.show !== "function") return;
    const headingEl = modal.querySelector("#WrpgWishlistModalHeading");
    const messageEl = modal.querySelector("#WrpgWishlistModalMessage");
    const ctaEl = modal.querySelector("#WrpgWishlistModalCta");
    const isError = reason === "error";
    if (headingEl) headingEl.textContent = isError ? modal.dataset.errorHeading : modal.dataset.loginHeading;
    if (messageEl) messageEl.textContent = isError ? modal.dataset.errorMessage : modal.dataset.loginMessage;
    if (ctaEl) ctaEl.hidden = isError;
    modal.show(opener);
  }

  function post(body) {
    return fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data) applyServerPayload(data);
        syncButtons();
        announce();
        if (window.wrpgWishlist && window.wrpgWishlist.sync) {
          // Mutual exclusion may have dropped wishlist rows - refresh hearts
          // from the next wishlist fetch rather than guessing. A lightweight
          // re-GET keeps the two maps in sync after an exclude.
          fetch("/apps/wrpg/wishlist")
            .then((response) => (response.ok ? response.json() : null))
            .then((wishlist) => {
              if (wishlist && window.wrpgWishlist.applyServerPayload) {
                window.wrpgWishlist.applyServerPayload(wishlist);
              }
            })
            .catch(() => {});
        }
      })
      .catch(() => {});
  }

  function labelsFrom(button) {
    return {
      headingExclude: button.dataset.pickerHeading,
      hintExclude: button.dataset.pickerHint,
      save: button.dataset.pickerSave || "Save",
      excludeAll: button.dataset.pickerExcludeAll || "Exclude entire product",
      excludeAllActive: button.dataset.pickerExcludeAllActive || "This product is fully excluded",
      modeWishlist: button.dataset.pickerModeWishlist,
      modeExclude: button.dataset.pickerModeExclude,
      loading: button.dataset.pickerLoading || "Loading…",
      error: button.dataset.pickerError || "Couldn't load variants.",
      owned: button.dataset.pickerOwned || "Owned",
    };
  }

  function openPicker(button) {
    const handle = button.dataset.productHandle;
    const productId = button.dataset.productId;
    const launch = () => {
      const excludeIds = [...(state.items.get(handle) || new Set())].map((id) => (id === "" ? null : id));
      const owned = (window.wrpgOwnership && window.wrpgOwnership.getOwnedVariantIds(productId)) || [];
      const wishlistIds =
        window.wrpgWishlist && window.wrpgWishlist.getVariantIds
          ? window.wrpgWishlist.getVariantIds(handle)
          : [];

      if (!window.wrpgVariantPickerModal) {
        toggleSimple(handle, productId);
        return;
      }

      window.wrpgVariantPickerModal.open({
        paintMode: "exclude",
        handle,
        productId,
        wishlistVariantIds: wishlistIds,
        excludeVariantIds: excludeIds,
        ownedVariantIds: owned,
        opener: button,
        labels: labelsFrom(button),
      });
    };

    const other = window.wrpgWishlist && window.wrpgWishlist.ready ? window.wrpgWishlist.ready() : Promise.resolve();
    Promise.resolve(other).then(launch).catch(launch);
  }

  function toggleSimple(handle, productId) {
    const willAdd = !isActive(handle);
    if (willAdd) state.items.set(handle, new Set([""]));
    else state.items.delete(handle);
    syncButtons();
    announce();
    post({ action: willAdd ? "add" : "remove", handle, productId });
  }

  function init() {
    state.ready = fetch(ENDPOINT)
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error("exclusions request failed"))))
      .then((data) => {
        if (data && data.loggedIn) {
          state.mode = "server";
          applyServerPayload(data);
        } else {
          state.mode = "guest";
          state.items = new Map();
        }
      })
      .catch(() => {
        state.mode = "error";
        state.items = new Map();
      })
      .then(() => {
        syncButtons();
        announce();
      });
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-wrpg-exclude-toggle]");
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    (state.ready || Promise.resolve()).then(() => {
      if (state.mode === "server") {
        const handle = button.dataset.productHandle;
        if (!handle) return;
        if (button.dataset.hasOnlyDefaultVariant === "true") {
          toggleSimple(handle, button.dataset.productId);
        } else {
          openPicker(button);
        }
        return;
      }
      openLoginModal(button, state.mode === "error" ? "error" : "guest");
    });
  });

  init();

  window.wrpgExclusions = {
    ready: () => state.ready || Promise.resolve(),
    isLoggedIn: () => state.mode === "server",
    getMode: () => state.mode,
    getHandles: () => [...state.items.keys()],
    getVariantIds: (handle) => [...(state.items.get(handle) || new Set())].map((id) => (id === "" ? null : id)),
    applyServerPayload: (data) => {
      applyServerPayload(data);
      syncButtons();
      announce();
    },
    sync: () => syncButtons(),
  };
})();
